export const searchQuery= (query: string) => `
*[
  (_type == "listing" || _type == "bonus" || _type == "category" || _type == "post") &&
  (    vendorName match "${query}*" 
    || bonusText match "${query}*" 
    || pageTitle match "${query}*"
    || pageDescription match "${query}*"
    || excerpt match "${query}*"
    || title match "${query}*"
  )
] {
  ...,
  "slug": slug.current,
      author{
          "name": @.reference->name,
          "bio": @.reference->bio,
          "userpic": @.reference->userpic,
          "socialMedias": @.reference->socialMedias
      }
}
`;